import {
  CLIENTES_ADD_CLIENTE_BEGIN,
  CLIENTES_ADD_CLIENTE_SUCCESS,
  CLIENTES_ADD_CLIENTE_FAILURE,
  CLIENTES_ADD_CLIENTE_DISMISS_ERROR,
  CLIENTES_SAME_CLIENT
} from './constants';
import axios from 'axios'
import { getEndpoint } from '../../common/backend/endpoints'
import * as commonActions from '../../common/redux/actions'

const endpoint_clientes = getEndpoint('CLIENTES')

export function addCliente(cliente) {
  return (dispatch) => {
    dispatch({
      type: CLIENTES_ADD_CLIENTE_BEGIN,
    });

    axios
    .post(endpoint_clientes, cliente)
    .then((newClienteData) => {
      dispatch(
        commonActions.SuccessAction({
          title: 'Cliente creado correctamente',
        }),
      );

      dispatch({
        type: CLIENTES_ADD_CLIENTE_SUCCESS,
        data: newClienteData.data.data
      });
    })
    .catch(err => {
      const dataError = err.response.data;      
      dispatch({
        type: CLIENTES_ADD_CLIENTE_FAILURE,
        data: dataError,
      });
      if (dataError.message.length > 0) {
        dataError.message.forEach(item => {
          dispatch(
            commonActions.WarningAction({
              title: item.msg,
            }),
          )
        })
      } else {
        dispatch(
          commonActions.ErrorAction({
            title: 'Error al crear cliente',
          }),
        )
      }
    })
  }
}

export function dismissAddClienteError() {
  return {
    type: CLIENTES_ADD_CLIENTE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CLIENTES_ADD_CLIENTE_BEGIN:
      return {
        ...state,
        guardadoClientePending: true,
        sameClient: false
      }
    case CLIENTES_ADD_CLIENTE_SUCCESS:
      return {
        ...state,
        guardadoClientePending: false,
        updateClienteSuccess: true,
        updatedClienteId: action.data.id,
        sameClient: false
      }
    case CLIENTES_ADD_CLIENTE_FAILURE: 
      return {
        ...state,
        guardadoClientePending: false,
        updateClienteError: action.data.dataError,
        sameClient: action.data.message[0].msg === CLIENTES_SAME_CLIENT
      }
    case CLIENTES_ADD_CLIENTE_DISMISS_ERROR: 
    return {
      ...state,
      updateClienteError: null, 
      sameClient: false
    }
    default:
      return state
  }
}